import React, { ReactNode } from 'react'
import styled from 'styled-components'
import { device } from '@styles/global/breakpoints'
import { SentinelHeadline1 } from '@styles/global/headlines'

interface IProps {
  subHead: string
  title: string
  texture?: {
    img: ReactNode,
  }
  bgImg?: ReactNode
  gridSize?: string
}

function HeaderLayoutA_V4({ title, subHead, texture, gridSize = '3/11', bgImg }: IProps) {

  return (
    <>
      {texture && <Texture>
        {texture.img}
      </Texture>}
      <Wrapper size={gridSize}>
        <span>{subHead}</span>
        <SentinelHeadline1>
          {title}
        </SentinelHeadline1>
        <BackgroundImage>
          {bgImg && bgImg}
        </BackgroundImage>
      </Wrapper>
    </>
  )
}

const Texture = styled.div`
  grid-column: 1/4;
  grid-row: 1;
  position: relative;
  img {
    position: absolute;
  }

  @media ${device.tablet} {
    grid-column: 1/8;
    img {
    }
  }

  @media ${device.laptop} {
    grid-column: 1/7;
    position: absolute;
    width: 100%;
  }
  @media ${device.laptopL} {
    grid-column: 2/7;
  }
`
const BackgroundImage = styled.div`
  position: absolute;
  top: -110px;
  right: 0;
  max-width: 200px;
  width: 100%;
  img {
    max-width: 100%;
  }
  
  @media ${device.tablet} {
    top: -120px;
    right: 170px;
  }
  
  @media ${device.laptop}{
    top: -100px;
    right: 90px;
  }
  
  @media ${device.laptopL} {
    right: -30px;
    top: -100px
  }
`
const Wrapper = styled.div<{ size: string }>`
  grid-column: 2/4;
  grid-row: 1;
  margin: 45px 0;
  position: relative;
  z-index: 2;
  h2 {
    margin: 0;
    font-size: 38px;
    position: relative;
  }
  span {
    color: ${props => props.theme.subheaderColor};
    font-size: 18px;
    font-weight: 600;
  }
  
  @media ${device.tablet} {
    grid-column: 2/9;
  }
  
  @media ${device.laptop} {
    grid-column: ${props => props.size};
    margin-right: 30px;
    h2{
      font-size: 44px;
    }
   }
  
  @media ${device.laptopL} {
      margin-bottom: 45px;
      max-width: 777px;
      h2{
        font-size: 60px;
      }
    }
`
export default HeaderLayoutA_V4
